const resultAbstractParts = {
	A1: 'woman',
	A2: 'man',
	A3: '',
	B1: 'rainy',
	B2: 'mountainous',
	B3: 'dry',
	B4: 'tropical',
	B5: 'temperate',
	B6: 'sunny',
	B7: 'urban',
	C1: 'polluted',
	C2: 'unpolluted',
	E1: 'face',
	E2: 'body',
	E3: 'hands & feet',
	E4: 'hair'
}

export default {
	localeName: 'English',
	mailForm: {
		heading:
			'L’OFFICINE UNIVERSELLE BULY IS A VAST AND WONDERFUL WORLD TO DISCOVER IF YOUR CURIOSITY IS GREAT AND YOUR ATTRACTION TO BEAUTY IS INSATIABLE. FOR AN INTRODUCTION IN THE RULES OF ART, PLEASE ENTER YOUR DETAILS.',
		firstNamePlaceholder: 'First Name',
		emailPlaceholder: 'Email',
		submissionSuccess:
			'Your subscription has been confirmed. Please check your mail.',
		submissionFail: 'An error occured. Please try later.',
		confirm: 'confirm',
		dataConsent_start: 'I give my consent and authorize Office Buly to',
		dataConsent_allow_send_recap:
			'send me the results of the Skin Concierge consultation by email',
		dataConsent_allow_collect:
			'collect, store and use my personal and potentially sensitive data in order to complete the Skin Concierge to provide you with a personalized Skin Concierge recommendation',
		marketingConsent:
			'send me personalized and exclusive information about Officine Universelle Buly news',
		infoText_0:
			'Officine Universelle Buly is responsible for processing the personal data you provide during your beauty diagnosis. Your personal and potentially sensitive data is processed by Officine Universelle Buly, subject to your consent, to manage your beauty diagnosis. It may also be used, with your prior consent, to send you personalized information, news, or events concerning our brand. This data will be linked to your customer account',
		infoText_1:
			'You can exercise your rights and also withdraw your consent at any time. For more information about your personal data, please consult our',
		infoText_2: 'Privacy Policy',
		infoText_2_href: 'https://buly1803.com/pages/privacy-policy',
		infoText_3: 'or contact our Data Protection Officer here',
		infoText_4: 'privacy@buly1803.com',
		infoText_4_href: 'mailto:privacy@buly1803.com',
		loading: 'Submitting...'
	},
	resultForm: {
		confirm: 'confirm'
	},
	result: {
		title: 'The Officine recommends',
		cta: 'Mirror, mirror on the wall, what are the best results of all?',
		button: 'Discover my results',
		concern: 'My concern',
		select: 'Select',
		unselect: 'Unselect',
		addCart: 'Display my cart',
		question: 'A question ?',
		recommend: 'Recommend to a friend',
		shops: 'Our boutiques',
		newSearch: 'Start a new one',
		discover: 'Discover',
		skip: 'Skip',
		showMore: 'Show more',
		tip: 'A witty advice from the Officine',
		endTitle: 'The officine collection of plant oil'
	},
	loading: 'Loading',
	// HARD CODED
	questions: {
		extra: {
			id: 'extra',
			bulyImage: '/img/portraits/portrait-skin.jpg',
			title: 'What is your skin tone?',
			analyticSlug: '0-what-is-your-skin-tone'
		}
	},
	diagnosis: {
		onTheWay: 'Our diagnosis is on the way',
		skip: 'Skip'
	},
	care_tag: {
		Care_Morning: 'Morning care',
		Care_Regular: 'Regular care',
		Care_Occasional: 'Occasional care',
		Care_Evening: 'Evening care',
		Care_Daily: 'Daily care',
		Care_Morning_Evening: 'Morning and Evening care'
	},
	store: 'https://www.buly1803.com/en/?concierge=',
	klaviyoId: 'VHmXJV',
	resultAbstract: ctx =>
		`You are a ${resultAbstractParts[ctx.named('gender')]} who lives in a ${
			resultAbstractParts[ctx.named('climate1')]
		} ${
			resultAbstractParts[ctx.named('climate2')]
		} environment, concerned about your ${
			resultAbstractParts[ctx.named('concern')]
		}`
}
